import React from 'react';

import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit';
import styles from './styles.css';

export interface IDescriptionProps {
  title?: string | null | undefined;
  text?: string | null | undefined;
  links?: { text: string; url: string }[];
}
//TODO разницу действий кнопки ссылка или модальное окно при инеграции с бекендом

export const Description: React.FC<IDescriptionProps> = ({ text, title, links }) => {
  return (
    <div className={styles['wrapper']}>
      {title ? <ArticleHeading4>{title}</ArticleHeading4> : null}
      {text ? <ArticleParagraph2>{text}</ArticleParagraph2> : null}
      {links
        ? links.map(({ text, url }, index) => {
            return (
              <a key={index} href={url} className={styles['link']}>
                {text}
              </a>
            );
          })
        : null}
    </div>
  );
};
